import {useState, useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {Grid, Box} from '@mui/material';
import FieldView2 from 'core/components/layout/FieldView2';


export default function ProductrawtorawdemandInfo(){
  const { productrawtorawdemandObj} = useSelector((state)=>state.pharmaslice.productrawtorawdemandDashboard);
    return (
      <Box lg={12} sx={{ flexGrow: 1 }}>
      <Grid item sx={{ overflowY: "scroll", backgroundColor: 'white', maxHeight: { xs: window.screen.height - 250, lg: window.screen.height } }}>
        
        <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        sx={{backgroundColor:'white'}}
      >
            
        <Grid item lg={4} xs={6}><FieldView2 label="Business Id"  value={ productrawtorawdemandObj.businessid!==null && productrawtorawdemandObj.businessid!==undefined?productrawtorawdemandObj.businessid:'NOT KNONWN' }/></Grid>
        <Grid item lg={4} xs={6}><FieldView2 label="Title"  value={ productrawtorawdemandObj.title!==null && productrawtorawdemandObj.title!==undefined?productrawtorawdemandObj.title:'NOT KNONWN' }/></Grid>
        <Grid item lg={4} xs={6}><FieldView2 label="Product Raw Id"  value={ productrawtorawdemandObj.productrawid!==null && productrawtorawdemandObj.productrawid!==undefined?productrawtorawdemandObj.productrawid:'NOT KNONWN' }/></Grid>
        <Grid item lg={4} xs={6}><FieldView2 label="Raw Demand Id"  value={ productrawtorawdemandObj.rawdemandid!==null && productrawtorawdemandObj.rawdemandid!==undefined?productrawtorawdemandObj.rawdemandid:'NOT KNONWN' }/></Grid>
      </Grid>
      </Grid>
      </Box>
    )
}